module.exports = __webpack_public_path__ + "img/04.ea7f2372.jpg";